import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CGISeverityModule } from 'modules/promptuary/components/cgi-severity/cgi-severity.module';
import { VCHistoryModule } from 'modules/video-conference/components/vc-history/vc-history.module';

import { AppointmentDetailsHistoricTabComponent } from './appointment-details-historic-tab.component';

@NgModule({
	declarations: [AppointmentDetailsHistoricTabComponent],
	imports: [CommonModule, CGISeverityModule, VCHistoryModule],
	exports: [AppointmentDetailsHistoricTabComponent],
	providers: [],
})
export class AppointmentDetailsHistoricTabModule {}
